import classnames from "classnames";
import PropTypes from "prop-types";
import { useEffect, useRef } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { pathToClassNames } from "../../helpers";
import PageNoMatch from "../../pages/NoMatch";
import useUserStore from "../../store/User.store";
import PageDefault from "./PageDefault";
import PageReport from "./PageReport";

import "./page.scss";

const Page = ({ template, subtitle, description, className }) => {
  const user = useUserStore((state) => state.data.user);
  const location = useLocation();
  const { pathname } = location;
  const pageRef = useRef(null);

  useEffect(() => {
    // replaced window.scrollTo due to andoid scroll issue
    pageRef.current?.scrollIntoView();
  }, [pathname]);

  if (!user && ["default", "report"].includes(template)) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return (
    <div
      ref={pageRef}
      className={classnames("page", pathToClassNames(pathname), className, {
        [`page--${template}`]: template,
      })}
    >
      <div className="page__wrapper">
        {(() => {
          switch (template) {
            case "nomatch":
              return (
                <PageNoMatch subtitle={subtitle} description={description} />
              );
            case "report":
              return <PageReport />;
            default:
              return <PageDefault />;
          }
        })()}
      </div>
    </div>
  );
};

Page.propTypes = {
  template: PropTypes.oneOf(["default", "report", "signin", "nomatch"]),
  subtitle: PropTypes.node,
  description: PropTypes.node,
  className: PropTypes.string,
};

Page.defaultProps = {
  template: "default",
};

export default Page;
